import { Component, Input } from '@angular/core';
import { ExtractedSingleShowcaseResource, ShowcasesTypes } from 'search/full-card/models/showcases';

@Component({
  selector: 'app-single-showcase-resource',
  templateUrl: './single-showcase-resource.component.html',
  styleUrls: ['./single-showcase-resource.component.scss'],
})
export class SingleShowcaseResourceComponent {
  @Input() public resource: ExtractedSingleShowcaseResource;
  @Input() public index: number;
  @Input() public showcaseType: ShowcasesTypes | string;
  @Input() public entityId: string;
}
